/* Salas García · Outlet: etiqueta de % de descuento, panel de filtros plano y botón "Cargar más" */
(function () {
  var doc = document;

  function parsePrice(t) {
    var n = (t || '').replace(/[^\d,.]/g, '');
    if (n.indexOf(',') > -1) n = n.replace(/\./g, '').replace(',', '.');
    return parseFloat(n);
  }

  /* 1. Etiqueta "−X %" en lugar de "Oferta" */
  function badges(root) {
    (root || doc).querySelectorAll('.card-wrapper').forEach(function (c) {
      if (c.dataset.sgb) return;
      c.dataset.sgb = '1';
      var reg = c.querySelector('.price__sale .price-item--regular');
      var sale = c.querySelector('.price__sale .price-item--sale');
      if (!reg || !sale) return;
      var r = parsePrice(reg.textContent);
      var s = parsePrice(sale.textContent);
      if (!(r > s && s > 0)) return;
      var pct = Math.round(100 * (1 - s / r));
      c.querySelectorAll('.card__badge .badge').forEach(function (b) {
        if (/oferta|sale/i.test(b.textContent)) {
          b.textContent = '−' + pct + ' %';
          b.setAttribute('data-sg-sale', '');
        }
      });
    });
  }

  /* 2. Panel lateral de filtros con todas las secciones visibles */
  function flat() {
    var w = doc.querySelector('.mobile-facets__wrapper');
    if (!w || w.classList.contains('sg-flat')) return;
    w.classList.add('sg-flat');
    var keep = function () {
      w.querySelectorAll('details.mobile-facets__details').forEach(function (d) {
        if (!d.open) d.setAttribute('open', '');
      });
    };
    keep();
    new MutationObserver(keep).observe(w, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    var sync = function () {
      var c = w.querySelector('.mobile-facets__count');
      var b = w.querySelector('.mobile-facets__footer .button--primary');
      if (!c || !b) return;
      var m = (c.textContent || '').match(/\d+/);
      if (!m) return;
      var txt = 'Ver ' + m[0] + (m[0] === '1' ? ' modelo' : ' modelos');
      if (b.textContent.trim() !== txt) b.textContent = txt;
    };
    sync();
    new MutationObserver(sync).observe(w, { subtree: true, childList: true, characterData: true });
  }

  /* 3. Cargar más */
  var state = { cur: 1, total: 1 };

  function pageInfo() {
    var nav = doc.querySelector('#ProductGridContainer .pagination-wrapper');
    if (!nav) return { cur: 1, total: 1 };
    var nums = [].slice.call(nav.querySelectorAll('.pagination__item')).map(function (e) {
      return parseInt(e.textContent.trim(), 10);
    }).filter(function (n) { return n > 0; });
    var curEl = nav.querySelector('[aria-current="page"]');
    return { cur: curEl ? parseInt(curEl.textContent, 10) || 1 : 1, total: nums.length ? Math.max.apply(null, nums) : 1 };
  }

  function totalItems(fallback) {
    var el = doc.getElementById('ProductCount') || doc.getElementById('ProductCountDesktop');
    var m = el && el.textContent.match(/\d+/);
    return m ? parseInt(m[0], 10) : fallback;
  }

  function update() {
    var box = doc.querySelector('.sg-more');
    var grid = doc.getElementById('product-grid');
    if (!box || !grid) return;
    var shown = grid.children.length;
    var total = Math.max(totalItems(shown), shown);
    box.querySelector('.sg-more__t').textContent = 'Has visto ' + shown + ' de ' + total + ' modelos';
    box.querySelector('.sg-more__bar i').style.width = Math.max(4, Math.round(100 * shown / total)) + '%';
    var btn = box.querySelector('.sg-more__btn');
    btn.hidden = state.cur >= state.total;
    btn.disabled = false;
    btn.textContent = 'Cargar más modelos';
  }

  function setup() {
    var cont = doc.getElementById('ProductGridContainer');
    if (!cont) return;
    badges(cont);
    var wrap = cont.querySelector('.collection');
    var grid = doc.getElementById('product-grid');
    if (!wrap || !grid || wrap.querySelector('.sg-more')) return;
    var pi = pageInfo();
    state.cur = pi.cur;
    state.total = pi.total;
    if (pi.total <= 1) return;
    var box = doc.createElement('div');
    box.className = 'sg-more';
    box.innerHTML = '<p class="sg-more__t"></p><div class="sg-more__bar"><i></i></div><button type="button" class="sg-more__btn">Cargar más modelos</button>';
    wrap.appendChild(box);
    update();
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sg-more__btn');
    if (!b) return;
    var grid = doc.getElementById('product-grid');
    if (!grid) return;
    b.disabled = true;
    b.textContent = 'Cargando…';
    var url = new URL(window.location.href);
    url.searchParams.set('page', state.cur + 1);
    fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        d.querySelectorAll('#product-grid > li').forEach(function (li) {
          var n = doc.importNode(li, true);
          n.classList.add('scroll-trigger--cancel');
          n.querySelectorAll('.scroll-trigger').forEach(function (x) { x.classList.add('scroll-trigger--cancel'); });
          grid.appendChild(n);
        });
        state.cur += 1;
        badges(grid);
        update();
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = 'Reintentar';
      });
  });

  function init() {
    flat();
    setup();
    var cont = doc.getElementById('ProductGridContainer');
    if (cont) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(setup, 60);
      }).observe(cont, { childList: true });
    }
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
